module.exports = __webpack_public_path__ + "img/alert.ca16d1e1.svg";